<template>
  <a
    v-if="helpstyle==''"
    id="help-btn"
    :href="helpURL"
    class="help"
  >Help</a>
  <a v-if="helpstyle=='menu'" :href="helpURL">
    <BaseMenuButton>
      <SVGIcon :width="'24px'" :height="'24px'" :iconName="'chat'" />
      <span>Help Center</span>
    </BaseMenuButton>
  </a>
  <a v-if="helpstyle=='login'" :href="helpURL" class="mt-2 button button-secondary form-button">
    <SVGIcon
      class="me-1"
      :iconName="'book'"
      :width="'14px'"
      :height="'14px'"
    />
    Getting Started
  </a>
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';

export default {
  name: 'HelpButton',
  components: {
    SVGIcon,
    BaseMenuButton,
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    helpstyle: {
      type: String,
      default: "",
    },
  },
  computed: {
    helpURL() {
      let domainPrefix = "https://doc.edgefirst.ai/latest/";

      if (window.location.host.includes('localhost', 0)) domainPrefix = "https://doc.edgefirst.ai/test/";
      if (window.location.host.includes('test', 0)) domainPrefix = "https://doc.edgefirst.ai/test/";
      if (window.location.host.includes('stage', 0)) domainPrefix = "https://doc.edgefirst.ai/stage/";
      if (window.location.host.includes('dev', 0)) domainPrefix = "https://doc.edgefirst.ai/test/";

      return domainPrefix + this.url;
    },
  },
};
</script>

<style lang="scss" scoped>

.help {
  background-color: #4c7a60;
  color: #f4f4f5;
  font-size: medium !important;
  padding: 4px;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 10px;
  border-radius: 8px;
  align-self: flex-end;
  text-decoration: none;
  margin-bottom: 8px;
  cursor: pointer;
}

.form-button {
  letter-spacing: 0.1em;
  width: 100%;
  height: 35px;
  border-radius: 6px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  text-decoration: none;
}
</style>
